import CardMensagem from './CardMensagem'

export default CardMensagem